export const bannerTextContent = {
  content: [
    {
      titleText: (
        <>
          Slot Game <span>Development</span>
        </>
      ),
      paraText:
        "GammaSlots specializes in crafting visually stunning slot games that blend next-gen features and exceptional game mechanics, offer flawless and immersive gameplay, and deliver unforgettable slot gaming experiences.",
      imageSrc: "/assets/stock-img/banner_character_img_01.webp",
      imageSrcContact: "/assets/stock-img/banner_contact_img_01.webp",
    },
    {
      titleText: (
        <>
          Slot Game <span>Development</span>
        </>
      ),
      paraText:
        "GammaSlots specializes in crafting visually stunning slot games that blend next-gen features and exceptional game mechanics, offer flawless and immersive gameplay, and deliver unforgettable slot gaming experiences.",
      imageSrc: "/assets/stock-img/banner_character_img_02.webp",
      imageSrcContact: "/assets/stock-img/banner_contact_img_02.webp",
    },
    {
      titleText: (
        <>
          Slot Game <span>Development</span>
        </>
      ),
      paraText:
        "GammaSlots specializes in crafting visually stunning slot games that blend next-gen features and exceptional game mechanics, offer flawless and immersive gameplay, and deliver unforgettable slot gaming experiences.",
      imageSrc: "/assets/stock-img/banner_character_img_03.webp",
      imageSrcContact: "/assets/stock-img/banner_contact_img_03.webp",
    },
  ],
};
